export const spaceSizes = {
  none: '0px',
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  mdPlus: '24px',
  lg: '32px',
  lgPlus: '40px',
  xl: '48px',
  xxl: '56px',
};

export const paddingSizes = {
  none: '0px',
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  mdPlus: '24px',
  lg: '32px',
  lgPlus: '40px',
  xl: '48px',
  xxl: '56px',
};

export const radiusSizes = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '24px',
  circle: '50%',
};

export const borderSizes = {
  none: '0px',
  sm: '0.5px',
  md: '1px',
  lg: '2px',
};

export const fontFamilies = {
  workSans: 'Work Sans',
  trirong: 'Trirong',
};

export const fontWeights = {
  regular: 400,
  semiBold: 500,
  bold: 600,
};

export const fontSizes = {
  xs: '11px',
  sm: '12px',
  smPlus: '13px',
  md: '14px',
  mdPlus: '16px',
  lg: '18px',
  lgPlus: '21px',
  xl: '24px',
  xlPlus: '28px',
  xxl: '32px',
  xxlPlus: '40px',
};

export const lineHeights = {
  lh50: '1.10',
  lh100: '1.15',
  lh200: '1.2',
  lh300: '1.25',
  lh400: '1.30',
  lh500: '1.40',
  lh600: '1.50',
  lh700: '1.60',
  lh800: '1.80',
  lh900: '2',
  lh950: '2.40',
};

export const colors = {
  slate: {
    l50: 'var(--color-slate-50)',
    l100: 'var(--color-slate-100)',
    l200: 'var(--color-slate-200)',
    l300: 'var(--color-slate-300)',
    l400: 'var(--color-slate-400)',
    l500: 'var(--color-slate-500)',
    l600: 'var(--color-slate-600)',
    l700: 'var(--color-slate-700)',
    l800: 'var(--color-slate-800)',
    l900: 'var(--color-slate-900)',
    l950: 'var(--color-slate-950)',
  },
  neutral: {
    l0: 'var(--color-neutral-0)',
    l50: 'var(--color-neutral-50)',
    l100: 'var(--color-neutral-100)',
    l200: 'var(--color-neutral-200)',
    l300: 'var(--color-neutral-300)',
    l400: 'var(--color-neutral-400)',
    l500: 'var(--color-neutral-500)',
    l600: 'var(--color-neutral-600)',
    l700: 'var(--color-neutral-700)',
    l800: 'var(--color-neutral-800)',
    l900: 'var(--color-neutral-900)',
    l950: 'var(--color-neutral-950)',
    l1000: 'var(--color-neutral-1000)',
  },
  red: {
    l50: 'var(--color-red-50)',
    l100: 'var(--color-red-100)',
    l200: 'var(--color-red-200)',
    l300: 'var(--color-red-300)',
    l400: 'var(--color-red-400)',
    l500: 'var(--color-red-500)',
    l600: 'var(--color-red-600)',
    l700: 'var(--color-red-700)',
    l800: 'var(--color-red-800)',
    l900: 'var(--color-red-900)',
    l950: 'var(--color-red-950)',
  },
  orange: {
    l50: 'var(--color-orange-50)',
    l100: 'var(--color-orange-100)',
    l200: 'var(--color-orange-200)',
    l300: 'var(--color-orange-300)',
    l400: 'var(--color-orange-400)',
    l500: 'var(--color-orange-500)',
    l600: 'var(--color-orange-600)',
    l700: 'var(--color-orange-700)',
    l800: 'var(--color-orange-800)',
    l900: 'var(--color-orange-900)',
    l950: 'var(--color-orange-950)',
  },
  amber: {
    l50: 'var(--color-amber-50)',
    l100: 'var(--color-amber-100)',
    l200: 'var(--color-amber-200)',
    l300: 'var(--color-amber-300)',
    l400: 'var(--color-amber-400)',
    l500: 'var(--color-amber-500)',
    l600: 'var(--color-amber-600)',
    l700: 'var(--color-amber-700)',
    l800: 'var(--color-amber-800)',
    l900: 'var(--color-amber-900)',
    l950: 'var(--color-amber-950)',
  },
  yellow: {
    l50: 'var(--color-yellow-50)',
    l100: 'var(--color-yellow-100)',
    l200: 'var(--color-yellow-200)',
    l300: 'var(--color-yellow-300)',
    l400: 'var(--color-yellow-400)',
    l500: 'var(--color-yellow-500)',
    l600: 'var(--color-yellow-600)',
    l700: 'var(--color-yellow-700)',
    l800: 'var(--color-yellow-800)',
    l900: 'var(--color-yellow-900)',
    l950: 'var(--color-yellow-950)',
  },
  lime: {
    l50: 'var(--color-lime-50)',
    l100: 'var(--color-lime-100)',
    l200: 'var(--color-lime-200)',
    l300: 'var(--color-lime-300)',
    l400: 'var(--color-lime-400)',
    l500: 'var(--color-lime-500)',
    l600: 'var(--color-lime-600)',
    l700: 'var(--color-lime-700)',
    l800: 'var(--color-lime-800)',
    l900: 'var(--color-lime-900)',
    l950: 'var(--color-lime-950)',
  },
  green: {
    l50: 'var(--color-green-50)',
    l100: 'var(--color-green-100)',
    l200: 'var(--color-green-200)',
    l300: 'var(--color-green-300)',
    l400: 'var(--color-green-400)',
    l500: 'var(--color-green-500)',
    l600: 'var(--color-green-600)',
    l700: 'var(--color-green-700)',
    l800: 'var(--color-green-800)',
    l900: 'var(--color-green-900)',
    l950: 'var(--color-green-950)',
  },
  emerald: {
    l50: 'var(--color-emerald-50)',
    l100: 'var(--color-emerald-100)',
    l200: 'var(--color-emerald-200)',
    l300: 'var(--color-emerald-300)',
    l400: 'var(--color-emerald-400)',
    l500: 'var(--color-emerald-500)',
    l600: 'var(--color-emerald-600)',
    l700: 'var(--color-emerald-700)',
    l800: 'var(--color-emerald-800)',
    l900: 'var(--color-emerald-900)',
    l950: 'var(--color-emerald-950)',
  },
  teal: {
    l50: 'var(--color-teal-50)',
    l100: 'var(--color-teal-100)',
    l200: 'var(--color-teal-200)',
    l300: 'var(--color-teal-300)',
    l400: 'var(--color-teal-400)',
    l500: 'var(--color-teal-500)',
    l600: 'var(--color-teal-600)',
    l700: 'var(--color-teal-700)',
    l800: 'var(--color-teal-800)',
    l900: 'var(--color-teal-900)',
    l950: 'var(--color-teal-950)',
  },
  cyan: {
    l50: 'var(--color-cyan-50)',
    l100: 'var(--color-cyan-100)',
    l200: 'var(--color-cyan-200)',
    l300: 'var(--color-cyan-300)',
    l400: 'var(--color-cyan-400)',
    l500: 'var(--color-cyan-500)',
    l600: 'var(--color-cyan-600)',
    l700: 'var(--color-cyan-700)',
    l800: 'var(--color-cyan-800)',
    l900: 'var(--color-cyan-900)',
    l950: 'var(--color-cyan-950)',
  },
  sky: {
    l50: 'var(--color-sky-50)',
    l100: 'var(--color-sky-100)',
    l200: 'var(--color-sky-200)',
    l300: 'var(--color-sky-300)',
    l400: 'var(--color-sky-400)',
    l500: 'var(--color-sky-500)',
    l600: 'var(--color-sky-600)',
    l700: 'var(--color-sky-700)',
    l800: 'var(--color-sky-800)',
    l900: 'var(--color-sky-900)',
    l950: 'var(--color-sky-950)',
  },
  blue: {
    l50: 'var(--color-blue-50)',
    l100: 'var(--color-blue-100)',
    l200: 'var(--color-blue-200)',
    l300: 'var(--color-blue-300)',
    l400: 'var(--color-blue-400)',
    l500: 'var(--color-blue-500)',
    l600: 'var(--color-blue-600)',
    l700: 'var(--color-blue-700)',
    l800: 'var(--color-blue-800)',
    l900: 'var(--color-blue-900)',
    l950: 'var(--color-blue-950)',
  },
  indigo: {
    l50: 'var(--color-indigo-50)',
    l100: 'var(--color-indigo-100)',
    l200: 'var(--color-indigo-200)',
    l300: 'var(--color-indigo-300)',
    l400: 'var(--color-indigo-400)',
    l500: 'var(--color-indigo-500)',
    l600: 'var(--color-indigo-600)',
    l700: 'var(--color-indigo-700)',
    l800: 'var(--color-indigo-800)',
    l900: 'var(--color-indigo-900)',
    l950: 'var(--color-indigo-950)',
  },
  violet: {
    l50: 'var(--color-violet-50)',
    l100: 'var(--color-violet-100)',
    l200: 'var(--color-violet-200)',
    l300: 'var(--color-violet-300)',
    l400: 'var(--color-violet-400)',
    l500: 'var(--color-violet-500)',
    l600: 'var(--color-violet-600)',
    l700: 'var(--color-violet-700)',
    l800: 'var(--color-violet-800)',
    l900: 'var(--color-violet-900)',
    l950: 'var(--color-violet-950)',
  },
  purple: {
    l50: 'var(--color-purple-50)',
    l100: 'var(--color-purple-100)',
    l200: 'var(--color-purple-200)',
    l300: 'var(--color-purple-300)',
    l400: 'var(--color-purple-400)',
    l500: 'var(--color-purple-500)',
    l600: 'var(--color-purple-600)',
    l700: 'var(--color-purple-700)',
    l800: 'var(--color-purple-800)',
    l900: 'var(--color-purple-900)',
    l950: 'var(--color-purple-950)',
  },
  fuchsia: {
    l50: 'var(--color-fuchsia-50)',
    l100: 'var(--color-fuchsia-100)',
    l200: 'var(--color-fuchsia-200)',
    l300: 'var(--color-fuchsia-300)',
    l400: 'var(--color-fuchsia-400)',
    l500: 'var(--color-fuchsia-500)',
    l600: 'var(--color-fuchsia-600)',
    l700: 'var(--color-fuchsia-700)',
    l800: 'var(--color-fuchsia-800)',
    l900: 'var(--color-fuchsia-900)',
    l950: 'var(--color-fuchsia-950)',
  },
  pink: {
    l50: 'var(--color-pink-50)',
    l100: 'var(--color-pink-100)',
    l200: 'var(--color-pink-200)',
    l300: 'var(--color-pink-300)',
    l400: 'var(--color-pink-400)',
    l500: 'var(--color-pink-500)',
    l600: 'var(--color-pink-600)',
    l700: 'var(--color-pink-700)',
    l800: 'var(--color-pink-800)',
    l900: 'var(--color-pink-900)',
    l950: 'var(--color-pink-950)',
  },
  rose: {
    l50: 'var(--color-rose-50)',
    l100: 'var(--color-rose-100)',
    l200: 'var(--color-rose-200)',
    l300: 'var(--color-rose-300)',
    l400: 'var(--color-rose-400)',
    l500: 'var(--color-rose-500)',
    l600: 'var(--color-rose-600)',
    l700: 'var(--color-rose-700)',
    l800: 'var(--color-rose-800)',
    l900: 'var(--color-rose-900)',
    l950: 'var(--color-rose-950)',
  },
};
